import React, { ReactElement } from 'react'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'

export type TendencyTypes = 'UP' | 'UNCHANGED' | 'DOWN'

export type TendencyProps = {
    children?: never
    type?: TendencyTypes
}

type TendencyStyles = {
    name: string
    color: string
}

const getTendencyStyles = (type: TendencyTypes): TendencyStyles => {
    switch (type) {
        case 'UP':
            return {
                name: 'scroll-top',
                color: 'GREEN',
            }
        case 'UNCHANGED':
            return {
                name: 'unchanged',
                color: 'keshi-3',
            }
        case 'DOWN':
            return {
                name: 'scroll-bottom',
                color: 'RED',
            }
    }
}

const Tendency = ({ type }: TendencyProps): ReactElement | null => {
    if (type) {
        const { name, color } = getTendencyStyles(type)
        return <FontelloIcon name={name} color={color} fontSize={8} />
    }
    return null
}

export default Tendency
